<template>
  <div class="">
    <div class="appVersion">{{appVersion}}</div>
  </div>
</template>
<script>
  import Helper from '@/helper/Helper';

  export default {
    name: 'AppVersion',
    data(){
      return {
        Helper: Helper
        , state: {} // local copy of state. refresh by original state data change by stateHash watcher
        , appVersion: ""
      }
    },
    watch: {
    },
    mounted() {
      const modul = this;
      modul.fillAppVersion();
    },
    methods: {
      fillAppVersion(){
        const modul = this;
        if(modul.$store.state && modul.$store.state.appVersion) {
//          const frontendVersion = modul.state.frontendVersion.replace(/"/g, '').replace(/'/g, '');
          const appVersion = modul.$store.state.appVersion.replace(/"/g, '').replace(/'/g, '');
          modul.appVersion = appVersion;
        }
      }
    },
  };
</script>

<style scoped>
  .appVersion{
    position: fixed;
    top: 0;
    right: 5px;
    color:grey;
    font-size: 10px;
  }
</style>

